module.exports = __webpack_public_path__ + "img/bg-login-br.bd56a7af.png";